import { forwardRef, type Ref, type SVGProps } from "react";
const IconPanelLeftOpenOutlineSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path d="M18.704 12.404a1 1 0 0 1 1.414 0l2.969 2.97a1 1 0 0 1 0 1.413l-3.016 3.016a1 1 0 0 1-1.414-1.414l2.308-2.309-2.261-2.262a1 1 0 0 1 0-1.414" />
    <path
      fillRule="evenodd"
      d="M26.5 2.001c1.858-.067 3.424 1.275 3.5 3v23c-.078 1.073-.999 1.928-2.154 2H4.154C3 29.93 2.078 29.074 2 28.001v-23c.076-1.725 1.642-3.067 3.5-3zm-21 2c-.664-.053-1.256.387-1.346 1v23h7.196v-24zm21 0H13.32v24h14.526v-23c-.09-.613-.682-1.053-1.346-1"
      clipRule="evenodd"
    />
  </svg>
);
const ForwardRef = forwardRef(IconPanelLeftOpenOutlineSVG);
ForwardRef.displayName = "IconPanelLeftOpenOutline";
export { ForwardRef as IconPanelLeftOpenOutline };
